// import 'whatwg-fetch';
import 'abortcontroller-polyfill';

export default function fetchRequest(requestUrl, requestOpts) {
  const controller = new AbortController();
  const signal = controller.signal;
  const { timeout=0, ...opts } = {...requestOpts, ...{signal}};
  const request = new Request(requestUrl, opts);
  const fetchPromise = fetch(request);
  const completedRequest = new Promise((resolve, reject) => {
    let timeoutId = timeout && setTimeout(() => {
      // Reject Promise With Error Message
      reject(new Error(`Request timed out after ${timeout} milliseconds.`));
      controller.abort();
    }, timeout) || null;
    
    fetchPromise
      .then((promiseVal) => {
        clearTimeout(timeoutId);
        resolve(promiseVal);
      })
      .catch(result => reject(result));
  });
  return completedRequest;
}